module.exports = __webpack_public_path__ + "img/lgOut.92d2b604.svg";